import { menuItemWithIcon } from "../../types/common";
import { ReactComponent as OverviewIcon } from "../../assets/icons/overview.svg";
import { ReactComponent as GanttChartIcon } from "../../assets/icons/gantt-chart.svg";
import { ReactComponent as CalendarSettingsIcon } from "../../assets/icons/gear.svg";
import NavgationListItem from "./NavigationListItem";
import navigationStyles from "../../styles/navigation.module.css";
import { useLocation } from "react-router-dom";

const PageNavigation = () => {
  const location = useLocation();

  const pageNavigationMenu: menuItemWithIcon[] = [
    {
      icon: <OverviewIcon width={16} height={16} />,
      title: "Oversigt",
      redirectUrl: "/overview" + location.search,
    },
    {
      icon: <GanttChartIcon width={16} height={16} />,
      title: "Tidsplan",
      redirectUrl: "/ganttChart" + location.search,
    },
  ];

  const allowedDevDomains = ["omsorg-dev.pondoo.ai", "localhost"];
  const isCalendarSettingsShown = allowedDevDomains.includes(
    window.location.hostname,
  );

  if (isCalendarSettingsShown) {
    pageNavigationMenu.push({
      icon: <CalendarSettingsIcon width={16} height={16} />,
      title: "Calendar",
      redirectUrl: "/calendarSettings" + location.search,
    });
  }

  return (
    <section className={navigationStyles.navigationList}>
      <nav className={navigationStyles.navigationListMenuWrapper}>
        {pageNavigationMenu.map((menuItem, index) => (
          <NavgationListItem menuItem={menuItem} key={index} />
        ))}
      </nav>
    </section>
  );
};

export default PageNavigation;
